import type { DraftQuestion, GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';

export type BalanceArenaChoice = { id: string; label: string; correct: boolean; mediaUrl?: string };
export type BalanceArenaQuestion = {
  id: number; questionId: string; prompt: string; promptMediaUrl?: string; choices: BalanceArenaChoice[];
};
export type BalanceArenaConfig = { id: string; questions: BalanceArenaQuestion[]; repeatUntilFall: boolean };
type Source = Pick<GameDraft | PublishedGame, 'id' | 'maxLevels' | 'questions' | 'repeatUntilFall'>;

function toQuestion(question: DraftQuestion, level: number): BalanceArenaQuestion {
  return {
    id: level, questionId: question.id, prompt: question.prompt, promptMediaUrl: question.media?.url,
    choices: question.choices.map((choice) => ({ id: choice.id, label: choice.text, correct: choice.isCorrect, mediaUrl: choice.media?.url })),
  };
}

export function draftToBalanceArenaConfig(source: Source): BalanceArenaConfig {
  const questions = Array.from({ length: source.maxLevels }, (_, index) => {
    const level = index + 1;
    const question = source.questions.find((candidate) => candidate.levels[0] === level);
    if (!question) throw new Error(`${level}. Denge Arenası sorusu bulunamadı.`);
    return toQuestion(question, level);
  });
  return { id: source.id, questions, repeatUntilFall: source.repeatUntilFall === true };
}
